import { useState, useEffect } from "react";
import type { Question } from "@shikaku/shared";
import { loadQuestions } from "@shikaku/shared";

export function useQuestions(url: string, shuffleChoices: boolean) {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    loadQuestions(url, shuffleChoices)
      .then((qs) => {
        if (!cancelled) {
          setQuestions(qs);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(String(err));
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [url, shuffleChoices]);

  return { questions, loading, error };
}
